import { AlertColor } from "@mui/material";

export enum SnackbarMessage {
  CREATE_FOLDER = "Folder Creation in progress",
  SYNC_SITE_SETTINGS_RETRY = "Site settings in progress",
  ERROR = "Something went wrong!",
  SUCCESS = "Success",
  UPDATE_FILE = "Update Files in progress",
  SYNC_CEM = "Sync with CEM in progress",
  RETRY_SYNC_CEM = "Retry for Sync with CEM in progress",
  SYNC_PS = "Populating Project Status Started",
  SYNC_IR = "Populating IR Started",
  POPULATE_DM_CHOICES = "Populating Document Metadata Started",
  POPULATE_LEGAL_ENTITIES = "Populating Legal Entities Started",
  POPULATE_THIRD_PARTY_ORG = "Populating Third-party Organization Started",
  POPULATE_MEMBER_FIRM_ORG = "Populating Member Firm Organization Started",
  POPULATE_CONTROVERSY_TRACKER = "Populating Entities in Controversy Tracker Isheet Started",
  SCHEDULE_PROGRESS = "Schedule Files Updates in progress",
  SCHEDULE_DETAILS = "Loading log details",
  UPDATE_SITE = "Update site in progress",
  REMOVE_MAPPING = "Site Archiving in progress",
  REMOVE_MAPPING_SUCCESS = "Site Archiving successful",
  REMOVE_MAPPING_FAIL = "Site Archiving Failed",
  SYNC_MDM_PROJECTS = "Sync MDM Projects in progress",
  SYNC_MDM_PHASES = "Sync MDM Phases in progress",
  SYNC_MDM = "Sync with MDM in progress",
  NO_SITE = "Site not found",
  CUSTOM_PERMISSIONS = "Updation of Custom Permissions in progress",
  CUSTOM_PERMISSIONS_SITE_SETUP_INVALID = "For all the entities present folders are not present. Please setup the site correctly before proceeding.",
  MOVE_IMANAGE_FILES = "Copying iManage files in progress. You can navigate away from the screen.",
  MOVE_TAXPORTAL_FILES = "Copying Tax Portal files in progress. You can navigate away from the screen.",
  IMANAGE_FILES_NO_DATA = "There is no data for: %item%",
  IMANAGE_FILES_NO_MODIFY = "The files have not been modified",
  UNARCHIVE_SITE = "Activation of Site in progress",
  ADDCLIENTID_SITENAME = "Addition of ClientId to Site name in progress",
  ADDCLIENTID_ORGEXISTS = "This Orgnaisation name already exists in HighQ",
  SITE_EXISTS = " could not be reactivated. A site with the same name exists.",
  SITE_EXISTS_WITHCLIENTID = " could not be updated. A site with the same name exists.",
  ORGANIZATION_EXISTS_CLIENTID = " could not be updated. An organisation with the same name exists.",
  UNARCHIVE_SUCCESS = "Activation of Site was successful",
  ADDCLIENTID_SUCCESS = "Addition of ClientId to Site name was successful",
  ADDCLIENTID_FAIL = "Addition of ClientId to Site name Failed",
  UNARCHIVE_FAIL = "Site Activation Failed",
  ROLLOVER_FILES = "Getting rollover files.",
  ROLLOVER_ARCHIVE_FILE_REMOVAL = "Rollover Archive File Removal in Progress.",
  ROLLOVER_STATUS_DETAILS = "Getting rollover status details.",
  ROLLOVER_PROGRESS = "Rollover is in progress.",
  ROLLOVER_NOW_PROGRESS = "Rollover Now is in progress. You can navigate away from the screen.",
  SCHEDULE_ROLLOVER = "Rollover schedule in progress.",
  CANCEL_SCHEDULE = "Cancelling scheduled rollover.",
  SITE_SETTINGS_PROGRESS = "Settings update in progress.",
  SITE_SETTINGS_FIELD_REQUIRED = "This field is required.",
  SITE_SETTING_EXIST = "%item% already exist. You can edit settings directly in the list.",
  SITE_SETTING_CREATED = "Site Setting created.",
  SITE_SETTING_UPDATED = "Site Setting updated.",
  SITE_SETTING_DELETED = "Site Setting deleted.",
  LEGAL_ENTITIES_EDIT_SUCCESS = "Updation of Legal Entities Inprogress",
  LEGAL_ENTITIES_EDIT_FAIL = "Updation of Legal Entities Failed",
  FOLDER_PERMISSION_UPDATE = "Updation of Folder Permission Successful",
  FOLDER_TAXYEAR_PROGRESS = "Updation of Folder TaxYear in progress",
  VIEW_PERMISSION_UPDATE = "Updation of View Permission Successful",
  EMAIL_CUSTOMPERMISSIONS = "Successfully sent an email with Custom Permission Failures",
  EMAIL_CUSTOMPERMISSIONS_FAIL = "Sending an email with failures failed",
  FOLDER_TAXYEAR_UPDATE = "Updation of Folder TaxYear Started",
  FOLDER_TAXYEAR_UPDATE_FAIL = "Updation of Folder Permission Failed",
  FOLDER_PERMISSION_UPDATE_FAIL = "Updation of Folder Permission Failed",
  VIEW_PERMISSION_UPDATE_FAIL = "Updation of View Permission Failed",
  SITE_SETTINGS_EDIT_SUCCESS = "Updation of Site Settings Inprogress",
  SITE_SETTINGS_EDIT_FAIL = "Updation of Site Settings Failed",
  SITE_NAME_EDIT_SUCCESS = "Updation of Site Name Successful",
  SITE_NAME_EXISTS = " already exists. Please use a different Site Name",
  SITE_NAME_EDIT_FAIL = "Updation of Site Name Failed",
  SITE_DATES_EDIT_FAIL = "Updation of Site Dates Failed",
  RETRIEVE_SITE_CHANGES = "Looking for changes detail. It could take a while...",
  PROCEED_TO_UPGRADE = "Procesing information. It could take a while...",
  TRANSITION_PLAN = "Populating Isheet Transition plan",
  DELIVERY_PLAN = "Populating Isheet Delivery plan",
  PROJECT_SETUP_TASK_TEMPLATES = " Populating Isheet Project Setup Template plan",
  ANALYTIC_INSIGHT_SETUP = " Isheet Analytic Insight ",
  RECORD_EXISTS_POPUP = "If you proceed, the system will remove corresponding choice options in the Entity, Project, Phase dropdowns and will apply the following changes accordingly:\n\n-Suppress in Folders - hide associated folders with the selected entities from non-admin roles.\n-Suppress in Information Request - delete choices from the entity dropdown in IR isheet and delete associated projects and phases choices associated with those entities.\n-Suppress in Project Status - delete associated Project Status records with the selected entities and delete choices from the entity dropdown in Project Status isheet and delete associated projects and phases choices associated with those entities.\n\nAre you sure you want to proceed?",
  CREATE_THIRDPARTY_ORGS = "Creation of Third Party Organization is in progress",
  UPDATE_THIRDPARTY_ORGS = "Updation of Third Party Organization is in progress",
  CREATE_THIRDPARTY_ORGS_SUCCESS = "Creation of Third Party Organization is Successful",
  UPDATE_THIRDPARTY_ORGS_SUCCESS = "Updation of Third Party Organization is Successful",
  SITE_SETUP = "Site SetUP in progress",
  EXPORT_TO_EXCEL_FAIL = "Export to excel Failed",
  EXPORT_TO_EXCEL_SUCCESS = "Successfully exported data to excel",
  IDM_AND_CEM = "Adding External User in Progress.",
  EX_IDM_AND_CEM = "Adding Third-Party User in Progress.",
  ASSIGN_USER_TO_SITE = "Assign User to site in Progress.",
  CHECK_EXTERNAL_USER_STATUS = "Check Status in Progress.",
  DOWNLOAD_MESSAGE = "Downloading file.",
  DOWNLOAD_FAILED = "Info from site %site% couldn't be downloaded.",
  ZIP_DOWNLOAD_FAILED = "The info couldn't be downloaded.",
  COMPARISON_EXCEL_DOWNLOAD_MESSAGE = "This process will download all the changes from selected sites.",
  ZIP_UPGRADE_DOWNLOAD_MESSAGE = "This process will download data only for sites already upgraded.",
  PROVIDE_APP_ACCESS = "Provide Site Role access in Progress.",
  RETRY_FOR_SITE_CREATION = "Retry for Site Creation Started.",
  PROVIDE_CONTENT_ADMIN_ACCESS = "Provide Content Admin access in Progress.",
  MEMBER_FIRM = "Provide Member Firm access in Progress.",
  CS_Run_Sites_API = "CS - Run Sites API in Progress.",
  RUN_ISHEET_TRIGGER_API = "CS - Run Isheet Trigger API in Progress.",
  REMOVE_THRID_PARTY_ORGANISATION = "Third-Party Organisation removed successfully.",
  CANNOT_REMOVE_THIRD_PARTY_ORG = "Cannot Remove Organisation. Unassign Users assigned to {0} before removal.",
  CONTROVERSY_TRACKER_USERS = "Central Controversy Tracker user sync in progress",
  CONTROVERSY_TRACKER_DELETED_RECORDS = "Central Controversy Tracker deleted records sync in progress",
  CONTROVERSY_TRACKER_RECORDS_SYNC = "Central Controversy Tracker records sync in progress",
  SYNC_IMANAGE_WORKSPACE_PER_SITE = "Syncing IManage WorkSpaces started",
  PROCEED_TO_BATCH_UPGRADE = "Upgrade Sites in progress",
  CONTROVERSY_TRACKER_LEGACY_RECORD = "Central Controversy Tracker legacy record sync in progress",
  VALIDATION_IS_IN_PROGRESS = "Validation is in progress",
  IMANAGE_WORKSPACES_REFRESH = "Refresh Imanage Workspaces is in Progress.",
  IMANAGE_WORKSPACES_REFRESH_SUCCESS = "Refresh Imanage Workspaces is Successful.",
  IMANAGE_WORKSPACES_REFRESH_FAIL = "Refresh Imanage Workspaces Failed.",
  TAXPORTAL_FOLDER_REFRESH = "Refresh TaxPortal Folders is in Progress.",
  TAXPORTAL_FOLDER_REFRESH_SUCCESS = "Refresh TaxPortal Folders is Successful.",
  TAXPORTAL_FOLDER_REFRESH_FAIL = "Refresh TaxPortal Folders Failed.",
  CORPOATESITE_FOLDER_REFRESH = "Refresh Corporate Sight Folders is in Progress.",
  CORPOATESITE_FOLDER_REFRESH_SUCCESS = "Refresh Corporate Sight Folders is Successful.",
  CORPOATESITE_FOLDER_REFRESH_FAIL = "Refresh Corporate Sight Folders Failed.",
  HANDLE_USER_SYNC = "Handle User Sync %%",
  FAILED_TO_SEND_MESSAGE = "Failed to send message. Please try again.",
  FAILED_TO_DELETE_MESSAGE = "Failed to delete message. Please try again.",
  LOADING_STATUS_DETAILS = "Loading status details...",
  FAILED_TO_LOAD_STATUS_DETAILS = "Failed to load status details.",
  STATUS_DETAILS_UPDATED = "Status details updated successfully.",
  FAILED_TO_SAVE_STATUS_DETAILS = "Failed to save status details.",
  PROJECT_SETTING_SUCCESS = "Project settings updated successfully.",
  PROJECT_DETAILS_UPDATED = "Project details updated successfully.",
  FAILED_MESSAGE = "Something went wrong while processing your request. Please confirm your changes saved and try again later.",
  SITE_SETTINGS_UPDATED = "Site Settings have been updated",
  SYNC_CUSTOM_VISUALIZATION_SUCCESS = "Syncing Custom visualization is in progress.",
  FAILED_TO_SYNC_Deliverables = "Failed to Sync Deliverables. Please try again later.",
  FAILED_TO_SYNC_K1_TRACKER = "Failed to Sync K1 Tracker. Please try again later.",
  FAILED_TO_SYNC_Document_Metadata = "Failed to Sync Document Metadata. Please try again later.",
  FAILED_TO_SYNC_INFORMATION_REQUEST_LIST = "Failed to Sync Information Request List. Please try again later.",
  FAILED_TO_SYNC_PROJECT_STATUS = "Failed to Sync Project Status. Please try again later.",
  SYNC_CUSTOM_VISUALIZATION_FAILED = "Failed to Sync Custom visualization. Please try again later.",
  PDC_ENABLED_SUCCESS = "PDC settings updated Successfully",
  PDC_ENABLED_FAILD = "PDC settings update Failed",
  SITE_CREATION_IN_PROGRESS = "Site creation is in progress",
}

export interface showSnackbarType {
  open?: boolean;
  message: SnackbarMessage | string;
  severity?: AlertColor;
}
